import { createSelector } from '@reduxjs/toolkit'
import { IPrivateFoundation } from '../../types'
import { RootState } from '../store'

const getMatchedPF = (state: RootState) => state.matchedPF.data
const getLoading = (state: RootState) => state.matchedPF.loading

const makeMatchedPF = createSelector([getMatchedPF], (matchedPF) => {
  const {
    technologyTitle = '',
    privateFoundation = {} as IPrivateFoundation,
    ...matched
  } = matchedPF

  const {
    organizationUrl = '',
    organizationDescription = '',
    contriPaidDsbrsChrtblAmt: disbursedCharityAmount = 0,
    ...pf
  } = privateFoundation

  const formattedDisbursedCharityAmount = disbursedCharityAmount.toLocaleString('en-US')

  return {
    ...pf,
    ...matched,
    technologyTitle,
    organizationUrl,
    disbursedCharityAmount,
    organizationDescription,
    formattedDisbursedCharityAmount,
  }
})

export const MatchedPFSelector = {
  getMatchedPF,
  getLoading,
  makeMatchedPF
}
